var _path, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 276 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 51V225C7 249.301 26.6995 269 51 269H225C249.301 269 269 249.301 269 225V51C269 26.6995 249.301 7 225 7H51C26.6995 7 7 26.6995 7 51Z",
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1953 140.788H77.2937C78.2097 140.788 79.0087 140.165 79.2329 139.277L95.6808 74.122C96.2227 71.9754 99.334 72.1695 99.6049 74.3668L115.773 205.492C116.049 207.731 119.244 207.871 119.714 205.664L140.505 108.176C140.948 106.103 143.886 106.051 144.402 108.107L158.423 164.059C158.87 165.844 161.287 166.129 162.137 164.497L175.518 138.823C175.862 138.162 176.546 137.747 177.291 137.747H207.293",
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210,
    cy: 137.5,
    rx: 25,
    ry: 30.5,
    fill: "#8E8E8E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVital);
export default __webpack_public_path__ + "static/media/vital.99734b3d7e522e002c8c7fca2d8574c8.svg";
export { ForwardRef as ReactComponent };